import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Briefcase, Award } from 'lucide-react';
const learningPoints = [{
  icon: Coffee,
  content: <>
        Dominarás el <span className="font-semibold" data-id="element-61">arte de hacer café</span>,
        como un{' '}
        <span style={{
      color: '#4F5D3B'
    }} data-id="element-62">
          barista profesional
        </span>
      </>
}, {
  icon: Briefcase,
  content: <>
        Transformarás tu <span className="font-semibold" data-id="element-63">pasión</span> en un{' '}
        <span style={{
      color: '#4F5D3B'
    }} data-id="element-64">
          negocio rentable
        </span>
      </>
}, {
  icon: Award,
  content: <>
        <span className="font-semibold" data-id="element-65">Te convertirás</span> en un{' '}
        <span style={{
      color: '#4F5D3B'
    }} data-id="element-66">
          experto/a
        </span>{' '}
        en el café
      </>
}];
export function LearningSection() {
  return <section className="py-10 bg-cream" data-id="element-67">
      <div className="max-w-2xl mx-auto px-6" data-id="element-68">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif text-coffee-dark text-center mb-8" data-id="element-69">
          ¿Qué aprenderás con este libro?
        </motion.h2>

        <div className="space-y-3" data-id="element-70">
          {learningPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-4 bg-white/50 border border-coffee-light/15 rounded-xl p-4" data-id="element-71">
              <div className="w-8 h-8 rounded-full bg-coffee-light/20 flex items-center justify-center shrink-0" data-id="element-72">
                <point.icon className="w-4 h-4 text-coffee" data-id="element-73" />
              </div>
              <p className="text-coffee-dark/80 text-sm leading-relaxed pt-1" data-id="element-74">
                {point.content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}